import React from 'react';
import { useGeneralStyles } from '~/shared/styles';
import { Caption } from '~/shared/Typography';
import Button from '~/shared/Button';

export const ActionButton = ({ title, onPress, ...props }: { title: string, onPress: () => void }) => {

    const gStyle = useGeneralStyles();

    return (
        <Button
            backgroundColor={gStyle.button_background}
            mt={10}
            onPress={onPress}
            {...props}
        >
            <Caption
                fontSize={20}
                color={gStyle.button_text}
                textAlign='left'
                px={30}
            >
                { title }
            </Caption>
        </Button>
    );
};
